import styled from 'styled-components';

import breakpoint from '~/utils/style-utils';

export const MenuWrapper = styled.div`
	z-index: 1;
	bottom: 0;
	left: 0;
	right: 0;
	top: 0;
	width: 100%;
	background-color: rgba(0, 0, 0, 0.6);

	${breakpoint.sm`
		position: fixed;
		height: 100%;
	`};

	${breakpoint.lg`
		position: absolute;
		height: 452px;
	`};
`;

export const MenuContainer = styled.div<{ hasRegulationHeader: boolean }>`
	position: absolute;
	left: 40px;
	right: 40px;
	top: ${props => (props.hasRegulationHeader ? 10 : 5)}%;
	background-color: var(--game-info-menu-background);
	border-radius: 12px;

	button:last-child::after {
		display: none;
	}
`;

export const MenuItemContainer = styled.button`
	position: relative;
	width: 100%;
	height: 48px;
	padding: 12px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;

	&::after {
		content: '';
		display: block;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 1px;
		background-color: var(--game-info-background-color);
	}
`;

export const MenuIconContainer = styled.div`
	width: 24px;
	height: 24px;
	margin-right: 11px;
`;

export const MenuTextContainer = styled.h3`
	font-weight: 600;
	font-size: 15px;
	line-height: 20px;
	text-align: left;
`;
